export default __webpack_public_path__ + "96fdc2d3dfa03e26e272789899a51664.png";